import { useGenericTranslate } from '@mb/i18n';

const definedTranslation = {
  material: 'collections-material-text',
  materials: 'collections-materials-text',
  'See all': 'collections-see-all',
  'List view': 'collections-list-view',
  'Add to Board': 'collections-add-to-board',
};

export const useTranslateCollections = () =>
  useGenericTranslate(definedTranslation);
